export default "__VITE_ASSET__0e442777__";